<template>
  <!--
    PC 목록 검색 행 공통 컴포넌트
    - 좌: leading / filters 슬롯 (select 등, shrink-0)
    - 우: 검색 입력 flex-1 (나머지 공간 전부) + 돋보기 아이콘
    - 하단: showDivider 시 굵은 구분선 (목록과의 시각 분리)
    - 피그마 스펙: gap-[8px], py-[8px], h-[48px], border #DDE1E4
  -->
  <div class="pc-list-search-row">
    <div class="flex items-center gap-[8px] w-full py-[8px]">
      <div class="flex items-center gap-[8px] shrink-0">
        <slot name="leading" />
        <slot name="filters" />
      </div>
      <div class="relative flex-1 min-w-0">
        <input
          v-model="keyword"
          type="text"
          :placeholder="placeholder"
          class="w-full h-[40px] pl-[12px] pr-10 border border-[#DDE1E4] rounded-[8px] text-[14px] text-[#222222] placeholder-[#BEC3C7] outline-none focus:border-[#A0CC4F] tracking-[-0.2px]"
          @keyup.enter="emit('search')"
        />
        <button
          type="button"
          class="absolute right-3 top-1/2 -translate-y-1/2 p-0 bg-transparent border-none cursor-pointer"
          aria-label="검색"
          @click="emit('search')"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="text-[#888888]">
            <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2" />
            <path d="m21 21-4.35-4.35" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
      </div>
      <div class="shrink-0 flex items-center gap-2">
        <slot name="actions" />
      </div>
    </div>
    <div v-if="showDivider" class="border-t-2 border-[#222222]" />
  </div>
</template>

<script setup lang="ts">
const keyword = defineModel<string>({ default: '' })

withDefaults(
  defineProps<{
    placeholder?: string
    /** 검색 행 바로 아래 굵은 선 (피그마 기준 없음 — 필요한 경우만 true로 지정) */
    showDivider?: boolean
  }>(),
  {
    placeholder: '검색어를 입력하세요.',
    showDivider: false,
  },
)

const emit = defineEmits<{
  (e: 'search'): void
}>()
</script>

<style scoped>
.pc-list-search-row :deep(.select-box-lg) {
  height: 40px;
  padding-top: 8px;
  padding-bottom: 8px;
  line-height: 1.4;
}
</style>
